import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { CookieService } from '../services/cookie-service/cookie.service';
import { AppLoadingService } from '../services/app-loading.service';

@Injectable({
    providedIn: 'root'
})
export class AuthRedirectGuard implements CanActivate {
    constructor(
        private cookieService: CookieService,
        private router: Router,
        private appLoading: AppLoadingService
    ) {}

    canActivate(): boolean {
        const hasSession = this.cookieService.hasSession();
        if (hasSession) {
            this.router.navigate(['/dashboard']);
            return false;
        }
        this.appLoading.hide();
        return true;
    }
}
